export enum ScenarioTransferType {
  AllAtOnce = 'ALL_AT_ONCE',
  OneByOne = 'ONE_BY_ONE',
}

export enum ScenarioTriggerType {
  AfterDatetime = 'AFTER_DATETIME',
  AfterInactivity = 'AFTER_INACTIVITY',
}

export enum ScenarioStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
  Canceled = 'CANCELLED',
}

export enum ScenarioTriggerCondition {
  OneOf = 'ONE_OF',
  AllOf = 'ALL_OF',
}
export enum ScenarioTransferCondition {
  OneOf = 'ONE_OF',
  AllOf = 'ALL_OF',
}

export enum ScenarioTransferStatus {
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  InQueue = 'IN_QUEUE',
  Received = 'RECEIVED',
}
